import { render, staticRenderFns } from "./ourSubInfoDetails.vue?vue&type=template&id=66415ed4&scoped=true"
import script from "./ourSubInfoDetails.vue?vue&type=script&lang=js"
export * from "./ourSubInfoDetails.vue?vue&type=script&lang=js"
import style0 from "./ourSubInfoDetails.vue?vue&type=style&index=0&id=66415ed4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66415ed4",
  null
  
)

export default component.exports